// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"b345938e","72":"17a5e469","94":"dca37778","561":"2a47eea9","633":"d9ca49a0","890":"40d5ea45","908":"544a7d8c","927":"0f2c0d79"}[chunkId] + ".chunk.css";
};